// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hX","cusMtdicon":"hX"};